import site from './site.js'
import dashboard from './dashboard.js'

export default {
  site,
  dashboard
}


// WEBPACK FOOTER //
// ./src/interface/routes/index.js